import React from 'react';
import './Button.css';
import { FaArrowRight } from 'react-icons/fa';

function Button({
  children,
  variant = 'primary',
  type = 'button',
  href,
  onClick,
  className = '',
  disabled = false,
  target,
  rel,
  icon = <FaArrowRight />,
  ...rest
}) {
  const buttonClassName = [`ui-button`, `ui-button--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      <span className="ui-button-text">{children}</span>
      {icon && (
        <div className="ui-button-icon-wrapper">
          {icon}
        </div>
      )}
    </>
  );

  if (href) {
    const resolvedRel = target === '_blank' ? rel || 'noopener noreferrer' : rel;

    return (
      <a className={buttonClassName} href={href} target={target} rel={resolvedRel} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button className={buttonClassName} type={type} onClick={onClick} disabled={disabled} {...rest}>
      {content}
    </button>
  );
}

export default Button;